import React from 'react';
import { useParams, useHistory } from 'react-router-dom'

import {
    makeStyles,
    TextField,
    Button,
    Box,
    CssBaseline
} from '@material-ui/core';
import idb from './helper/db';
import Crime from './model/Crime';
import AutoCompleteObject from './component/AutoCompleteObjectField';
import SubjectConfig, { Unit } from './helper/SubjectConfig';

export const modes = { new: "new", edit: "edit", copy: "copy" };

const categories: { value: string, label: string }[] = [
    { value: 'ca1000', label: 'Автоматика' },
    { value: 'ca0200', label: 'Газовое оборудование (в т.ч. сосуды под давлением)' },
    { value: 'ca1300', label: 'Готовность к ЧС' },
    { value: 'ca1200', label: 'Документация' },
    { value: 'ca1100', label: 'Подъемные механизмы' },
    { value: 'ca0800', label: 'Пожарная безопасность' },
    { value: 'ca0900', label: 'Произв. безопасность при работах' },
    { value: 'ca0750', label: 'Санитария' },
    { value: 'ca0600', label: 'Схемы, бирки, обозначения' },
    { value: 'ca0500', label: 'Территория, здания, сооружения' },
    { value: 'ca0400', label: 'Транспорт' },
    { value: 'ca0700', label: 'Экология' },
    { value: 'ca0300', label: 'Электрооборудование' },
];

const useStyles = makeStyles(theme => ({
    textField: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    menu: {
        width: 200,
    },
    btnSave: {
        marginTop: theme.spacing(3),
    },
}));



const CrimeDetail: React.FC = () => {
    const { uuid, mode } = useParams();

    const history = useHistory();
    const classes = useStyles();

    const units: Unit[] = SubjectConfig.getLocal().units;
    const [crime, setCrime] = React.useState<Crime>(new Crime());
    const db = new idb();
    const validate = () => {
        if (crime.objectName === "" || crime.objectName.length < 3) return false;
        if (crime.categoryId === "c0" || crime.categoryId === '') return false;
        if (crime.crimeDescription === "" || crime.crimeDescription.length < 10) return false;
        if (crime.sendToUnitId === "u0" || crime.sendToUnitId === "") return false;
        return true;
    }

    React.useEffect(() => {
        switch (mode) {
            case modes.new:
                break;
            case modes.edit:
                db.crimeTable.get(uuid).then((crime: Crime | undefined) => {
                    if (crime !== undefined) {
                        setCrime(crime);
                        console.log("crime=" + JSON.stringify(crime));
                    } else {
                        console.error('crime edit not found, uuid:' + uuid);
                    }
                });
                break;
            case modes.copy:
                db.crimeTable.get(uuid).then((crime: Crime | undefined) => {
                    if (crime !== undefined) {
                        let newCrime = new Crime();
                        newCrime.objectId = crime.objectId;
                        newCrime.objectName = crime.objectName;
                        newCrime.sendToUnitId = crime.sendToUnitId;
                        setCrime(newCrime);
                    } else {
                        console.error('crime copy not found, uuid:' + uuid);
                    }
                });
                break;
            default:
                break;
        }
        // eslint-disable-next-line
    }, [mode, uuid])

    const saveCrime = () => {
        if (mode === modes.new || mode === modes.copy) {
            db.crimeTable.add(crime).then((id => {
                console.log("new crime saved, id = " + id);
                history.goBack();
            }))
        } else {
            //TODO можно убрать первый параметр crime.uuid
            db.crimeTable.update(crime.uuid, crime).then((id => {
                console.log("crime updated, id = " + id);
                history.goBack();
            }))
        }
    }



    return (
        <Box p={1}>
            <CssBaseline />
            <form noValidate autoComplete="off">
                <AutoCompleteObject

                    objectId={crime.objectId}
                    objectName={crime.objectName}
                    onChange={(objectId: string, objectName: string) => {
                        let newCrime = Object.assign({}, crime) as Crime;
                        newCrime.objectId = objectId;
                        newCrime.objectName = objectName;
                        setCrime(newCrime);
                        console.log('update crime object ', objectId, objectName);
                    }} />

                <TextField label="Категория" fullWidth select
                    variant="outlined"
                    className={classes.textField}
                    value={crime.categoryId}
                    onChange={(event) => {
                        let newCrime = Object.assign({}, crime) as Crime;
                        newCrime.categoryId = event.target.value;
                        setCrime(newCrime);
                    }}
                    SelectProps={{
                        native: true,
                        MenuProps: {
                            className: classes.menu,
                        },
                    }}
                >
                    <option key={"c0"} value={""}>
                        {""}
                    </option>
                    {categories.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </TextField>
                <TextField label="Описание" fullWidth
                    className={classes.textField}
                    variant="outlined"
                    value={crime.crimeDescription}
                    onChange={(event) => {
                        let newCrime = Object.assign({}, crime) as Crime;
                        newCrime.crimeDescription = event.target.value;
                        setCrime(newCrime);

                    }}
                    multiline
                />
                <TextField label="Получатель" fullWidth select
                    variant="outlined"
                    className={classes.textField}
                    value={crime.sendToUnitId}
                    onChange={(event) => {
                        let newCrime = Object.assign({}, crime) as Crime;
                        newCrime.sendToUnitId = event.target.value;
                        setCrime(newCrime);
                    }}
                    SelectProps={{
                        native: true,
                        MenuProps: {
                            className: classes.menu,
                        },
                    }}
                >    <option key={"u0"} value={""}>
                        {""}
                    </option>
                    {units.map((unit: Unit) => (
                        <option key={unit.id} value={unit.id}>
                            {unit.title}
                        </option>
                    ))}
                </TextField>


                <Button fullWidth disabled={validate() === false}
                    variant="contained" color="secondary"
                    className={classes.btnSave}
                    onClick={() => saveCrime()}
                >Сохранить</Button>


            </form>
        </Box>
    );
}


export default CrimeDetail;
